import React from 'react';
import './Footer.css';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import EmailIcon from '@mui/icons-material/Email';

const Footer = () => {
  return (
    <div className='footer'>
      <footer className="footer-section">
    <div>
        <div className="footer-cta pt-5 pb-5">
            <div className="row">
                <div className="col-xl-4 col-md-4 mb-30">
                    <div className="single-cta">
                    
                        <div className="cta-text">
                            <h4><LocationOnIcon className='footer-icons'/> Find us</h4>
                            <span>Reg. F-022FF, Krishna Apra Plaza,
                            Alpha-1, Commercial Comple</span>
                            <span>Works. G-2, Site IV, Gautam Budh
                            Nagar- 201310</span>
                        </div>
                    </div>
                </div>
                <div className="col-xl-4 col-md-4 mb-30">
                    <div className="single-cta">
                        <i className="fas fa-phone"></i>
                        <div className="cta-text">
                            <h4>
                            <LocalPhoneIcon className='footer-icons'/> Call us</h4>
                            <span>+91-9711361720, <br />+91-7827460292</span>
                        </div>
                    </div>
                </div>
                <div className="col-xl-4 col-md-4 mb-30">
                    <div className="single-cta">
                        <i className="far fa-envelope-open"></i>
                        <div className="cta-text">
                            <h4>
                            <EmailIcon className='footer-icons'/> Mail us</h4>
                            <span>conwavesolution@gmail.com</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div>
        <div className='copyright'>
       <p>Copyright &copy; 2024, All Right Reserved <b>For CONWAVE POWER SOLUTION</b></p>
       </div>
        </div>
    </div>
</footer>

    </div>
  )
}

export default Footer
